import React, { forwardRef, useImperativeHandle, useRef, useState } from "react";
import { Checkbox, Stack, Typography } from "@curves/ui-base";

/**
 * 選取項目
 * @param {boolean} checked 控制選取狀態
 * @param {boolean} defaultChecked 預設選取狀態
 * @param {string} title 標題
 * @param {function} handleChange 狀態改變事件
 */
const PickItem = forwardRef((props, ref) => {
	const { checked, defaultChecked, title, handleChange: handleChangeProps } = props;
	const isControlled = checked !== undefined;
	const [helperTextData, setHelperTextData] = useState({
		isError: false,
		text: "錯了送不出去",
	});
	const checkRef = useRef();
	const handleChange = (e, checkedValue) => {
		handleChangeProps && handleChangeProps(checkedValue);
	};
	useImperativeHandle(
		ref,
		() => ({
			getResult: () => checkRef.current && checkRef.current.checked,
			setHelperText: (isError, text) => {
				if (isError && checkRef.current) {
					window.scrollTo({ top: checkRef.current.offsetTop, behavior: "smooth" });
				}
				setHelperTextData({ isError, text });
			},
		}),
		[],
	);

	return (
		<Stack alignItems="center">
			<Checkbox className="mr-1" ref={checkRef} checked={isControlled ? checked : undefined} defaultChecked={isControlled ? undefined : defaultChecked} color="primary" onChange={handleChange} />
			<Typography className="m-0 font-weight-bold">{title}</Typography>
			{helperTextData.isError && (
				<Typography className="m-0 ml-1" variant="body2" color="error">
					{helperTextData.text}
				</Typography>
			)}
		</Stack>
	);
});

PickItem.displayName = "PickItem";

export default PickItem;
